














import { Component, Vue } from 'vue-property-decorator'
import FuturVoisin from '@/components/Dashboard/FuturVoisin.vue'
import EspacesPartages from '@/components/Dashboard/EspacesPartages.vue'

@Component({
    components: {
        FuturVoisin,
        EspacesPartages,
    },
})
export default class LaCopro extends Vue {}
